import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import AddProjects from './pages/AddProjects';
import AddStudents from './pages/AddStudents';
import NotFound from './pages/NotFound';

import CustomCursor from './components/ui/CustomCursor';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <CustomCursor />
        <div className="min-h-screen bg-gradient-to-br from-darker via-dark to-darker">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin/admin/adminlogin" element={<AdminLogin />} />
            <Route path="/dashboard" element={<AdminDashboard />} />
            <Route path="/showprojects" element={<AddProjects />} />
            <Route path="/showstudents" element={<AddStudents />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
